<template>
  <template v-if="item">
    <!-- 分隔线 -->
    <template v-if="item.type === 'separator'">
      <div class="toolbar-separator"></div>
    </template>

    <!-- label类型 -->
    <template v-else-if="item.type === 'label'">
      <div 
        class="toolbar-label"
        :class="{ 'toolbar-label-white': item.customType === 'primary-white' }"
        :title="item.tooltip || ''"
        :style="[
          { 
            height: '38px',
            padding: '8px 8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',            
            color: '#333',
          },
          item.customStyle || {}
        ]"
      >
        <!-- 移除内联 font-size：14px -->
        <component
          v-if="item.icon"
          :is="item.icon"
          class="toolbar-item-icon"
        />
        <i 
          :class="item.icon" 
          v-else-if="item.icon" 
          class="toolbar-item-icon"
        ></i>
        <span v-if="item.label">{{ item.label }}</span>
      </div>
    </template>    
    
    <!-- 自定义组件 -->
    <template v-else-if="item.type === 'custom' && item.render">
      <div class="custom-content">
        <component :is="item.render()" />
      </div>
    </template>

    <!-- 普通按钮 -->
    <template v-else-if="item.type === 'button' || !item.type">
      <button
        class="toolbar-button"
        :class="{ disabled: item.disabled , 'toolbar-button-white': item.customType === 'primary-white' }"
        :title="item.tooltip || ''"
        @click.stop="handleClick"
        :disabled="item.disabled"
        :style="item.customType === 'primary-white' ? [
              { 
                backgroundColor: 'white', 
                color: '#333',
                border: '1px solid #e0e0e0',
                borderRadius: '4px'
              },
              item.customStyle || {}
            ] : {}"
      >
        <!-- 移除内联 font-size：14px -->
        <component
          v-if="item.icon"
          :is="item.icon"
          class="toolbar-item-icon"
        />
        <i :class="item.icon" v-else-if="item.icon" class="toolbar-item-icon"></i>
        <span v-if="item.label">{{ item.label }}</span>
      </button>
    </template>    

    <!-- 下拉菜单 -->
    <template v-else-if="item.type === 'dropdown'">
      <div class="dropdown" :class="{ disabled: item.disabled }" ref="dropdownRef">
        <!-- 触发按钮 -->
        <button
          class="toolbar-button dropdown-trigger"
          :title="item.tooltip || ''"
          @click.stop="toggleMainMenu"
          @blur="handleBlur"
          :disabled="item.disabled"
        >
          <!-- 移除内联 font-size：14px -->
          <component
            v-if="item.icon"
            :is="item.icon"
            class="toolbar-item-icon"
          />
          <i
            :class="item.icon"
            v-else-if="item.icon"
            class="toolbar-item-icon"
          ></i>
          <span v-if="item.label">{{ item.label }}2</span>
        </button>

        <!-- 一级菜单容器 -->
        <div
          class="dropdown-menu"
          v-if="showMenu && item.menuItems && item.menuItems.length"
          @click.stop
          @mouseenter="clearMenuCloseTimer"
          @mouseleave="handleMenuContainerMouseLeave"
          :style="{
            left: isMainMenuRightAligned ? 'auto' : '0',
            right: isMainMenuRightAligned ? '0' : 'auto',
            top: isMainMenuUpAligned ? 'auto' : '100%',
            bottom: isMainMenuUpAligned ? '100%' : 'auto',
            margin: isMainMenuUpAligned ? '0 0 8px 0' : '8px 0 0 0'
          }"
        >
          <template v-for="menu in item.menuItems" :key="menu.key">
            <template v-if="menu">
              <!-- 分隔线 -->
              <div v-if="menu.label === '---'" class="menu-separator" key="separator-{{ menu.key }}"></div>
              
              <!-- 有子菜单的项 -->
              <div
                v-else-if="menu.children && menu.children.length"
                class="menu-item has-children"
                :data-key="menu.key"
                key="has-child-{{ menu.key }}"
              >
                <div
                  class="menu-item-trigger"
                  @click.stop="toggleSubMenu(menu)"
                  @mouseenter="handleSubMenuMouseEnter(menu)"
                >
                  <div class="menu-icon-container">
                    <!-- 移除内联 font-size：14px -->
                    <component
                      v-if="menu.icon"
                      :is="menu.icon"
                      class="toolbar-item-icon"
                    />
                  </div>
                  <div class="menu-text-container">
                    <span>{{ menu.label }}</span>
                  </div>
                  <RightOutlined class="submenu-arrow" />
                </div>
                <!-- 子菜单 -->
                <div
                  class="dropdown-menu submenu"
                  v-if="menu.showSubMenu"
                  @mouseenter="menu.showSubMenu = true"
                  @mouseleave="menu.showSubMenu = false"
                  @click.stop
                  :style="{
                    left: isSubMenuRightAligned[menu.key] ? 'auto' : '100%',
                    right: isSubMenuRightAligned[menu.key] ? '0' : 'auto',
                    top: isSubMenuUpAligned[menu.key] ? 'auto' : '0',
                    bottom: isSubMenuUpAligned[menu.key] ? '0' : 'auto'
                  }"
                >
                  <SubMenu
                    :menuItems="menu.children"
                    @menu-click="handleSubMenuClick"
                     :isToolbar="true" 
                  />
                </div>
              </div>
              
              <!-- 普通菜单项 -->
              <div
                v-else
                class="menu-item"
                @click="handleMenuClick(menu.key)"
                :disabled="menu.disabled"
                key="normal-{{ menu.key }}"
              >
                <div v-if="menu.icon" class="menu-icon-container">
                  <!-- 移除内联 font-size：14px -->
                  <component
                    :is="menu.icon"
                    class="toolbar-item-icon"
                  />
                </div>
                <div v-else class="menu-icon-placeholder"></div>
                
                <div class="menu-text-container">
                  <span>{{ menu.label }}</span>
                </div>
                <div class="menu-triangle-placeholder"></div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </template>
  </template>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, defineAsyncComponent, watch } from "vue";
import type { ToolbarItemProps, ToolbarMenuItem } from "./Toolbar.vue";
import { RightOutlined } from "@ant-design/icons-vue";
import { nextTick } from "vue";


// 异步引入子菜单组件
const SubMenu = defineAsyncComponent(() => import("./SubMenu.vue"));

// Props 定义
const props = defineProps<{
  item: ToolbarItemProps;
  menuItems?: ToolbarMenuItem[];
}>();

// 关联模板中下拉菜单根元素的 ref
const dropdownRef = ref<HTMLDivElement | null>(null);

// 状态管理
const showMenu = ref(false);
let menuCloseTimer: NodeJS.Timeout | null = null;

// 左右对齐状态（一级菜单 + 子菜单）
const isMainMenuRightAligned = ref(false);
const isSubMenuRightAligned = ref<Record<string, boolean>>({});

// 新增：上下对齐状态（一级菜单 + 子菜单）- 控制是否向上弹出
const isMainMenuUpAligned = ref(false);
const isSubMenuUpAligned = ref<Record<string, boolean>>({});

// 计算子菜单位置（包含左右 + 上下适配）
const calculateSubMenuPosition = async () => {
  await nextTick();
  if (!dropdownRef.value) return;
  const menuItems = props.item.menuItems || [];
  
  menuItems.forEach((menu) => {
    if (!menu || !menu.children || !menu.children.length) return;
    
    // 查询当前组件内的子菜单触发项和子菜单元素
    const parentEl = dropdownRef.value.querySelector(`.menu-item.has-children[data-key="${menu.key}"]`);
    const subMenuEl = parentEl?.querySelector(".dropdown-menu.submenu");
    if (!parentEl || !subMenuEl) return;
    
    // 获取必要的尺寸和位置信息
    const subMenuRect = subMenuEl.getBoundingClientRect();
    const parentRect = parentEl.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    
    // 1. 子菜单左右判断：右侧超出视口 → 贴右
    const isOverflowRight = parentRect.right + subMenuRect.width > viewportWidth;
    isSubMenuRightAligned.value[menu.key] = isOverflowRight;
    
    // 2. 子菜单上下判断：底部超出视口 → 向上弹出
    const isOverflowBottom = parentRect.top + subMenuRect.height > viewportHeight;
    isSubMenuUpAligned.value[menu.key] = isOverflowBottom;
  });
};

// 计算一级菜单位置（包含左右 + 上下适配）
const calculateMainMenuPosition = async () => {
  await nextTick();
  if (!showMenu.value || !dropdownRef.value) return;
  
  const triggerEl = dropdownRef.value.querySelector(".dropdown-trigger");
  const mainMenuEl = dropdownRef.value.querySelector(".dropdown-menu");
  if (!triggerEl || !mainMenuEl) return;
  
  // 获取必要的尺寸和位置信息
  const triggerRect = triggerEl.getBoundingClientRect();
  const mainMenuRect = mainMenuEl.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  
  // 1. 一级菜单左右判断：右侧超出视口 → 贴右
  const isOverflowRight = triggerRect.right + mainMenuRect.width > viewportWidth;
  isMainMenuRightAligned.value = isOverflowRight;
  
  // 2. 一级菜单上下判断：底部超出视口 → 向上弹出
  const isOverflowBottom = triggerRect.bottom + mainMenuRect.height > viewportHeight;
  isMainMenuUpAligned.value = isOverflowBottom;
};

// 监听菜单显示状态，触发位置计算（左右 + 上下）
watch(showMenu, (newVal) => {
  if (newVal) {
    calculateMainMenuPosition();
    calculateSubMenuPosition();
  } else {
    // 菜单关闭时重置所有状态
    isSubMenuRightAligned.value = {};
    isSubMenuUpAligned.value = {};
    isMainMenuRightAligned.value = false;
    isMainMenuUpAligned.value = false;
  }
});

// 一级菜单切换
const toggleMainMenu = () => {
  showMenu.value = !showMenu.value;
};

// 清除菜单关闭计时器
const clearMenuCloseTimer = () => {
  if (menuCloseTimer) {
    clearTimeout(menuCloseTimer);
    menuCloseTimer = null;
  }
};

// 一级菜单容器鼠标离开：延迟关闭
const handleMenuContainerMouseLeave = () => {
  clearMenuCloseTimer();
  menuCloseTimer = setTimeout(() => {
    showMenu.value = false;
    props.item.menuItems?.forEach((menu) => {
      if (menu) menu.showSubMenu = false;
    });
  }, 200);
};

// 按钮失去焦点：延迟关闭
const handleBlur = () => {
  clearMenuCloseTimer();
  menuCloseTimer = setTimeout(() => {
    showMenu.value = false;
    props.item.menuItems?.forEach((menu) => {
      if (menu) menu.showSubMenu = false;
    });
  }, 200);
};

// 普通按钮点击
const handleClick = () => {
  if (props.item.disabled) return;
  if (props.item.onClick) {
    props.item.onClick();
  }
  console.log('emit click 事件');
  emit("click", props.item);
  // if (!props.item.disabled && props.item.onClick) {
  //   props.item.onClick();
  // }
  // emit("click", props.item);
};

// 普通菜单项点击
const handleMenuClick = (key: string) => {
  emit("menu-click", key);
  showMenu.value = false;
  props.item.menuItems?.forEach((menu) => {
    if (menu.children && menu.children.length) {
      menu.showSubMenu = false;
    }
  });
};


// 子菜单点击事件透传（关键：必须 emit 出去）
const handleSubMenuClick = (key: string) => {
  console.log("SubMenu 传递的 key：", key); // 可选：添加日志验证
  emit("menu-click", key); // 透传给父组件（比如 HomeView）
  showMenu.value = false;
  props.item.menuItems?.forEach((menu) => {
    if (menu) menu.showSubMenu = false;
  });
};

// 子菜单切换（包含位置重新计算）
const toggleSubMenu = (menu: ToolbarMenuItem) => {
  if (menu) {
    clearMenuCloseTimer();
    menu.showSubMenu = !menu.showSubMenu;
    if (menu.showSubMenu) {
      calculateSubMenuPosition(); // 子菜单显示时重新计算位置
    }
  }
};

// 窗口大小变化时，重新计算所有菜单位置（适配缩放）
const handleWindowResize = () => {
  if (showMenu.value) {
    calculateMainMenuPosition();
    calculateSubMenuPosition();
  }
};

// 点击外部关闭菜单（精准判断当前组件）
const handleClickOutside = (e: MouseEvent) => {
  if (!dropdownRef.value) return;
  if (!dropdownRef.value.contains(e.target as Node)) {
    showMenu.value = false;
    props.item.menuItems?.forEach((menu) => {
      if (menu.children && menu.children.length) {
        menu.showSubMenu = false;
      }
    });
    clearMenuCloseTimer();
  }
};

// 鼠标进入有子菜单项目时，关闭其他子菜单
const handleSubMenuMouseEnter = (currentMenu: ToolbarMenuItem) => {
  const allMenuItems = props.item.menuItems || [];
  allMenuItems.forEach((menu) => {
    if (menu !== currentMenu && menu.children && menu.children.length) {
      menu.showSubMenu = false;
    }
  });
  currentMenu.showSubMenu = true;
  calculateSubMenuPosition(); // 切换子菜单时重新计算位置
};

// 生命周期：绑定/解绑事件
onMounted(() => {
  document.addEventListener("click", handleClickOutside);
  window.addEventListener("resize", handleWindowResize);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
  window.removeEventListener("resize", handleWindowResize);
  clearMenuCloseTimer();
});

// 事件定义
const emit = defineEmits<{
  (e: "click", item: ToolbarItemProps): void;
  (e: "menu-click", menuKey: string): void;
}>();


</script>


<style scoped>
/* 分隔线样式 */
.toolbar-separator {
  width: 1px;
  height: 20px;
  background-color: #e0e0e0;
  align-self: center;
  margin: 0 8px;
}

/* 基础按钮样式 */
.toolbar-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px; 
  min-width: 40px;
  min-height: 36px;
  border-radius: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  /* 核心修改：改用 CSS 变量 */
  font-size: var(--font-size-base) !important;
  gap: 6px;
  transition: all 0.2s;
  outline: none;
  white-space: nowrap;    
  overflow: hidden;       
  text-overflow: ellipsis;
}

.toolbar-button:hover:not(.disabled) {
  background-color: rgba(0, 0, 0, 0.08);
}

.toolbar-button.disabled {
  color: #999;
  cursor: not-allowed;
}

/* 下拉菜单根容器 */
.dropdown {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* 一级菜单基础样式 */
.dropdown-menu {
  position: absolute;
  min-width: 160px;
  padding: 4px 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100;
  box-sizing: border-box;
}

/* 子菜单基础样式 */
.dropdown-menu.submenu {
  position: absolute;
  min-width: 160px;
  margin: 0;
  z-index: 101;
  max-width: calc(100vw - 20px);
  box-sizing: border-box;
  white-space: nowrap;
}

/* 菜单项基础样式 */
.menu-item {
  padding: 6px 10px;
  /* 核心修改：改用 CSS 变量 */
  font-size: var(--font-size-base) !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;
  justify-content: flex-start!important;
  text-align: left !important;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

/* 有子菜单的菜单项 */
.menu-item.has-children {
  position: relative;
}

/* 子菜单触发区 */
.menu-item-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 菜单图标容器（固定宽度） */
.menu-icon-container {
  margin-right: 8px;
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* 菜单文字容器（占满剩余空间） */
.menu-text-container {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: 1px;
}

/* 子菜单箭头 */
.submenu-arrow {
  /* 核心修改：改用 CSS 变量（可按比例缩小，如 0.85em） */
  font-size: calc(var(--font-size-base) * 0.85) !important;
  color: #666;
  width: 14px;
  flex-shrink: 0;
  text-align: center;
}

/* 普通菜单项右侧占位（与箭头宽度一致） */
.menu-triangle-placeholder {
  width: 14px;
  flex-shrink: 0;
}

/* 菜单分隔线 */
.menu-separator {
  height: 1px;
  margin: 4px 0;
  background-color: #eee;
  margin-left: 10px;
  margin-right: 10px;
}

/* 禁用菜单项样式 */
.menu-item.disabled {
  color: #999;
  cursor: not-allowed;
  background-color: transparent !important;
}

.menu-icon-placeholder {
  margin-right: 4px!important;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.custom-content {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 2px;
  pointer-events: auto !important;
  z-index: 1;
}

/* ========== 新增：覆盖模板中硬编码的字体大小 ========== */
:deep(.toolbar-label),
:deep(.toolbar-label span),
:deep(.toolbar-button span),
:deep(.toolbar-button .anticon),
:deep(.menu-icon-container .anticon) {
  font-size: var(--font-size-base) !important;
}
</style>